import * as THREE from "three";
import getPosInfo from "./getPosInfo";
import modelToMesh from "./modelToMesh";
import intersectMeshesPlitka from "./intersectMeshesPlitka";

const addPaving = async (model, xSize, zSize, minX, minZ, topHeight, additionalMaterial) => {

    // model = await modelToMesh(model);

    console.log(model);

    let finalGroup = new THREE.Group();
    let lineGroup = new THREE.Group();

    const dopusk = 0.001;

    const bboxModel = getPosInfo(model);

    const countInWidth = xSize / bboxModel.xSize;
    const countInWidthInt = Math.trunc(countInWidth);
    const countInWidthFract = countInWidth - countInWidthInt;

    const countInLength = zSize / bboxModel.zSize;
    const countInLengthInt = Math.trunc(countInLength);
    const countInLengthFract = countInLength - countInLengthInt;

    const sizeLastElementX = (xSize - bboxModel.xSize * countInWidthInt);
    const sizeLastElementZ = (zSize - bboxModel.zSize * countInLengthInt);

    model.position.set(
        minX + bboxModel.xSize / 2,
        topHeight + bboxModel.ySize / 2,
        minZ + bboxModel.zSize / 2
    );

    //Создаем полосу в ширину
    lineGroup.add(model);
    for (let index = 2; index <= countInWidthInt; index++) {
        const newModel = model.clone();
        newModel.position.x += (index - 1) * bboxModel.xSize;
        lineGroup.add(newModel);
    }

    if (countInWidthFract > dopusk) {
        const newModel = model.clone();
        newModel.position.x += countInWidthInt * bboxModel.xSize;
        newModel.updateMatrix();

        const bboxNewModel = getPosInfo(newModel);

        const cutMesh = new THREE.Mesh(
            new THREE.BoxGeometry(
                sizeLastElementX, bboxModel.ySize, bboxModel.zSize
            ),
            new THREE.MeshStandardMaterial()
        )
        cutMesh.position.copy(newModel.position);
        cutMesh.position.x = bboxNewModel.bbox.min.x + sizeLastElementX / 2
        cutMesh.updateMatrix()

        // const cutedModel = await intersectMeshesPlitka(newModel, cutMesh)
                const cutedModel = cutMesh;
        if (additionalMaterial) {
            cutedModel.traverse(function (node) {
                if (node.isMesh) {
                    if (!node.name.includes("_notexture")) {
                        node.material = additionalMaterial;
                    }
                }
            });
        }

        lineGroup.add(cutedModel);
    }

    finalGroup.add(lineGroup); // добавили 1ую линию

    for (let index = 2; index <= countInLengthInt; index++) {
        const newLineGroup = lineGroup.clone();

        newLineGroup.position.z += (index - 1) * bboxModel.zSize;
        finalGroup.add(newLineGroup);
    }

    if (countInLengthFract > dopusk) {
        const newModel = model.clone();

        newModel.position.z += countInLengthInt * bboxModel.zSize;
        newModel.updateMatrix();

        const bboxNewModel = getPosInfo(newModel);

        const cutMesh = new THREE.Mesh(
            new THREE.BoxGeometry(
                bboxModel.xSize, bboxModel.ySize, sizeLastElementZ
            ),
            new THREE.MeshStandardMaterial()
        )
        cutMesh.position.copy(newModel.position);
        cutMesh.position.z = bboxNewModel.bbox.min.z + sizeLastElementZ / 2
        cutMesh.updateMatrix()
        // const cutedModel = await intersectMeshesPlitka(newModel, cutMesh)
        const cutedModel = cutMesh;
        if  (additionalMaterial) {
            cutedModel.traverse(function (node) {
                if (node.isMesh) {
                    if (!node.name.includes("_notexture")) {
                        node.material = additionalMaterial;
                    }
                }
            });
        }
        finalGroup.add(cutedModel);
        cutedModel.updateMatrix()

        for (let index = 2; index <= countInWidthInt; index++) {
            const newModel = cutedModel.clone();
            newModel.position.x += (index - 1) * bboxModel.xSize;
            finalGroup.add(newModel);
        }
        if (countInWidthFract > dopusk) {

            const lastModel = model.clone();

            lastModel.position.z += countInLengthInt * bboxModel.zSize;
            lastModel.position.x += countInWidthInt * bboxModel.xSize;
            lastModel.updateMatrix();

            const bboxNewModel = getPosInfo(lastModel);
            const cutMesh = new THREE.Mesh(
                new THREE.BoxGeometry(
                    sizeLastElementX, bboxNewModel.ySize, sizeLastElementZ
                ),
                new THREE.MeshStandardMaterial()
            )
            cutMesh.position.copy(lastModel.position);
            cutMesh.position.x = bboxNewModel.bbox.min.x + sizeLastElementX / 2
            cutMesh.position.z = bboxNewModel.bbox.min.z + sizeLastElementZ / 2
            cutMesh.updateMatrix()

            const cutedModel = cutMesh
            // const cutedModel = await intersectMeshesPlitka(lastModel, cutMesh)

            if (additionalMaterial) {
                cutedModel.traverse(function (node) {
                    if (node.isMesh) {
                        if (!node.name.includes("_notexture")) {
                            node.material = additionalMaterial;
                        }
                    }
                });
            }

            finalGroup.add(cutedModel);
        }

    }
    return finalGroup;


}
export default addPaving;
